<template>
  <div class="main-page page-foreign-news">
    <Menu title="涉外服务动态" :home="true" />
    <div class="container-flex article-container">
      <article v-if="article" class="article">
        <h1>{{ article.title }}</h1>
        <div class="meta">来源：{{ article.source || article.author || '云南掌上12348' }}　时间：{{ article.post_time || article.date }}</div>
        <video v-if="article.video" controls><source :src="article.video" type="video/mp4"></video>
        <div class="detail" v-html="article.content"></div>
      </article>
      <div v-else class="state">正在加载…</div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'

export default {
  components: { Menu },
  data () { return { article: null } },
  async mounted () {
    try {
      this.article = await this.$api.getPostNewsView({ post_id: this.$route.params.id, code: '530000', platform: 'ZD' })
    } catch (error) {
      this.$message.error('内容加载失败')
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-foreign-news
  .article-container
    padding 0.2rem 1.2rem 0.5rem
  .article
    width 100%
    height 100%
    padding 0.45rem
    overflow-y auto
    border-radius 0.1rem
    background #fff
    color #333
    h1
      text-align center
      font-size 0.34rem
    .meta
      margin 0.2rem 0 0.35rem
      padding-bottom 0.2rem
      text-align center
      color #999
      border-bottom 1px solid #eee
    video
      display block
      max-width 100%
      margin 0 auto 0.3rem
    .detail
      font-size 0.2rem
      line-height 1.8
      >>> img
        max-width 100%
  .state
    color #fff
    font-size 0.24rem
</style>
